module.exports = __webpack_public_path__ + "media/images/undraw/shift/events-a5299e11066eb4ffac5f9769b5e57a00.png";